export default function NoBorderButtonSmall({onClick, children}){
    return (
        <>
            <span  onClick={onClick} className="font-Outfit font-medium text-sm text-black cursor-pointer">{children}</span>
        </>
    );
}